import { render, staticRenderFns } from "./Clock.vue?vue&type=template&id=20371285&scoped=true&"
import script from "./Clock.vue?vue&type=script&lang=ts&"
export * from "./Clock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20371285",
  null
  
)

export default component.exports